<template>
  <div class="topbar">
    <!-- Navbar -->
    <nav class="navbar-custom">
      <ul class="list-unstyled topbar-nav float-right mb-0">
        <li v-if="false" class="dropdown hide-phone">
          <a class="nav-link dropdown-toggle arrow-none waves-light waves-effect" data-toggle="dropdown" href="#" role="button"
             aria-haspopup="false" aria-expanded="false">
            <i class="topbar-icon far fa-search"></i>
          </a>

          <div class="dropdown-menu dropdown-menu-right dropdown-lg p-0">
            <!-- Top Search Bar -->
            <div class="app-search-topbar">
              <form action="#" method="get">
                <input type="search" name="search" class="from-control top-search mb-0" placeholder="جستجو ...">
                <button type="submit"><i class="ti-search"></i></button>
              </form>
            </div>
          </div>
        </li>

        <li class="dropdown notification-list">
          <a class="nav-link dropdown-toggle arrow-none waves-light waves-effect" data-toggle="dropdown" href="#" role="button"
             aria-haspopup="false" aria-expanded="false">
            <i class="align-self-center topbar-icon far fa-bell"></i>
            <span class="badge badge-danger badge-pill noti-icon-badge">2</span>
          </a>
          <div class="dropdown-menu dropdown-menu-right dropdown-lg pt-0">

            <h6 class="dropdown-item-text font-15 m-0 py-3 border-bottom d-flex justify-content-between align-items-center">
              اطلاعیه ها<span class="badge badge-primary badge-pill">2</span>
            </h6>
            <div class="notification-menu" data-simplebar>
              <!-- item-->
              <a href="#" class="dropdown-item py-3">
                <small class="float-right text-muted pl-2">2 دقیقه قبل</small>
                <div class="media">
                  <div class="avatar-md bg-soft-primary">
                    <i data-feather="shopping-cart" class="align-self-center icon-xs"></i>
                  </div>
                  <div class="media-body align-self-center ml-2 text-truncate">
                    <h6 class="my-0 font-weight-normal text-dark">سفارش شما ثبت شد</h6>
                    <small class="text-muted mb-0">لورم ایپسوم متن ساختگی با تولید سادگی</small>
                  </div><!--end media-body-->
                </div><!--end media-->
              </a><!--end-item-->
              <!-- item-->
              <a href="#" class="dropdown-item py-3">
                <small class="float-right text-muted pl-2">10 دقیقه قبل</small>
                <div class="media">
                  <div class="avatar-md bg-soft-primary">
                    <img src="assets/images/users/user-4.jpg" alt="" class="thumb-sm rounded-circle">
                  </div>
                  <div class="media-body align-self-center ml-2 text-truncate">
                    <h6 class="my-0 font-weight-normal text-dark">ملاقات با طراحان</h6>
                    <small class="text-muted mb-0">نامفهوم از صنعت چاپ و با استفاده از طراحان</small>
                  </div>
                </div><!--end media-->
              </a><!--end-item-->
              <!-- item-->
              <a href="#" class="dropdown-item py-3">
                <small class="float-right text-muted pl-2">40 دقیقه قبل</small>
                <div class="media">
                  <div class="avatar-md bg-soft-primary">
                    <i data-feather="users" class="align-self-center icon-xs"></i>
                  </div>
                  <div class="media-body align-self-center ml-2 text-truncate">
                    <h6 class="my-0 font-weight-normal text-dark">سه تسک طراحی تجربه کاربری تمام شد</h6>
                    <small class="text-muted mb-0">چاپگرها و متون بلکه روزنامه و مجله در ستون</small>
                  </div><!--end media-body-->
                </div><!--end media-->
              </a><!--end-item-->
              <!-- item-->
              <a href="#" class="dropdown-item py-3">
                <small class="float-right text-muted pl-2">1 ساعت قبل </small>
                <div class="media">
                  <div class="avatar-md bg-soft-primary">
                    <img src="assets/images/users/user-5.jpg" alt="" class="thumb-sm rounded-circle">
                  </div>
                  <div class="media-body align-self-center ml-2 text-truncate">
                    <h6 class="my-0 font-weight-normal text-dark">سفارش شما ثبت شد</h6>
                    <small class="text-muted mb-0">نامفهوم از صنعت چاپ و با استفاده از طراحان</small>
                  </div><!--end media-body-->
                </div><!--end media-->
              </a><!--end-item-->
              <!-- item-->
              <a href="#" class="dropdown-item py-3">
                <small class="float-right text-muted pl-2">2  ساعت قبل </small>
                <div class="media">
                  <div class="avatar-md bg-soft-primary">
                    <i data-feather="check-circle" class="align-self-center icon-xs"></i>
                  </div>
                  <div class="media-body align-self-center ml-2 text-truncate">
                    <h6 class="my-0 font-weight-normal text-dark">پرداخت موفقیت آمیز</h6>
                    <small class="text-muted mb-0">چاپگرها و متون بلکه روزنامه و مجله در ستون</small>
                  </div><!--end media-body-->
                </div><!--end media-->
              </a><!--end-item-->
            </div>
            <!-- All-->
            <a href="javascript:void(0);" class="dropdown-item text-center text-primary">
              مشاهده همه <i class="fi-arrow-right"></i>
            </a>
          </div>
        </li>

        <li class="dropdown">
          <a class="nav-link dropdown-toggle waves-effect waves-light nav-user" data-toggle="dropdown" href="#" role="button"
             aria-haspopup="false" aria-expanded="false">
            <span class="ml-1 nav-user-name hidden-sm">نیک</span>
            <img src="/" alt="profile-user" class="rounded-circle" />
          </a>
          <div class="dropdown-menu dropdown-menu-right">
            <a class="dropdown-item" href="#"><i class="align-self-center icon-xs icon-dual mr-2 far fa-user"></i>پروفایل</a>
            <a class="dropdown-item" href="#"><i class="align-self-center icon-xs icon-dual mr-2 far fa-cog"></i>تنظیمات</a>
            <div class="dropdown-divider mb-0"></div>
            <a class="dropdown-item" href="#"><i class="align-self-center icon-xs icon-dual mr-2 far fa-power-off"></i>خروج</a>
          </div>
        </li>
      </ul><!--end topbar-nav-->

      <ul class="list-unstyled topbar-nav mb-0">
        <li>
          <button @click="toggleMenu()" class="nav-link button-menu-mobile">
            <i class="align-self-center topbar-icon far fa-bars"></i>
          </button>
        </li>
      </ul>
    </nav>
    <!-- end navbar-->
  </div>
</template>

<script>
export default {
  name: "TopBar",
  methods :{
    toggleMenu()
    {
        document.body.classList.toggle("close_menu");
    }
  }
}
</script>

<style scoped>

</style>